import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment-timezone';
import { Moment } from 'moment';


@Pipe({ name: 'scheduleMomentFormatDate' })
export class ScheduleMomentFormatPipe implements PipeTransform {
  constructor() { }

  transform(date: any, format: string): any {
    let momentTime: Moment = moment.tz(date, Intl.DateTimeFormat().resolvedOptions().timeZone);
    let fromNow =  momentTime.format('YYYY-MM-DDTHH:mm:ss');
    if (date && !format) {
      if (
        moment().dayOfYear() === momentTime.dayOfYear() &&
        moment().year() === momentTime.year()
      ) {
        return momentTime.format('h:mm A z');
      }
      return momentTime.format('D MMMM YY, h:mm A z');
    } else if (date && format) {
      if (format === 'fromNow') {
        var value = moment(new Date(fromNow));
        return value.fromNow();
      } else if (format === 'calendar') {
        return momentTime.calendar();
      } else {
        return momentTime.format(format);
      }
    } else {
      return 'No Date and Time Selected';
    }
  }
}